export default __webpack_public_path__ + "static/media/docx-icon.9fbabd6d.svg";